import React, { useState } from "react";

function Hero() {
  const [thoughtsCount] = useState(() => Math.floor(Math.random() * 900) + 100); // Random between 100-999
  const [thingsCount] = useState(() => Math.floor(Math.random() * 90) + 10); // Random between 10-99

  return (
    <section className="min-h-screen flex items-center px-8 md:px-16 lg:px-24 pt-2">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 w-full max-w-7xl mx-auto">
        {/* Left Content */}
        <div className="flex flex-col justify-center">
          {/* Stats */}
          <div className="flex gap-12 mb-10">
            <div>
              <p className="text-5xl md:text-6xl font-bold text-primary">+{thoughtsCount}</p>
              <p className="text-base md:text-lg text-secondary">thoughts thunk</p>
            </div>
            <div>
              <p className="text-5xl md:text-6xl font-bold text-primary">+{thingsCount}</p>
              <p className="text-base md:text-lg text-secondary">lightbulbs lit</p>
            </div>
          </div>
          
          {/* Main Heading */}
          <h1 className="text-8xl md:text-9xl lg:text-[10rem] xl:text-[12rem] font-bold text-primary mb-8 leading-none">
            hello
          </h1>
          <p className="text-xl md:text-2xl text-secondary mb-10">
            curiosity in motion
          </p>
          
          {/* Scroll Down */}
          <button 
            onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
            className="flex items-center gap-2 text-primary hover:gap-3 transition-all focus-visible-ring rounded-md p-2"
            aria-label="Scroll to about section"
          >
            <span className="text-base md:text-lg">Scroll down</span>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </button>
        </div>
        
        {/* Right Content - Professional Portrait */}
        <div className="flex items-center justify-center lg:justify-end">
          <div className="w-full max-w-md lg:max-w-2xl p-4 md:p-8">
            <img 
              src="/BW-removebg.png" 
              alt="Professional portrait"
              className="w-full h-auto object-contain transform scale-110 md:scale-125 lg:scale-[1.35] xl:scale-[1.45]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
